export const casinoPromotionTypes = {
  game: 1,
  filter: 2,
  category: 3,
};

export const promotionTypes = {
  FEATURED: 1,
  ODDS: 2,
  MARKETING: 3,
  DEPOSIT: 4,
  OUTRIGHTS: 5,
  CASINO: 6,
  SPORTS: 7,
  REFER_A_FRIEND: 8,
};

export const promotionScreens = {
  SPORTS: 1,
  CASINO: 2,
  HORSE_RACING: 4,
  PROFILE: 5,
  GOLF: 6,
  F1: 7,
  SIGNUP: 8,
};

export const deeplinkPromoTypes = {
  sports: 'sports',
  event: 'event',
  competition: 'competition',
  casino: 'casino',
  promotions: 'promotions',
  raf: 'referAFriend',
};
